module.exports = __webpack_public_path__ + "static/media/phone-2-fill.0a521ac9.svg";